module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fwDWh"))).then(() => parcelRequire('4LSXO'));